import axios from 'axios';
import { buildApiUrl } from '../config/runtimeConfig';

// ใช้ process.env สำหรับ Create React App

const api = axios.create({
  baseURL: buildApiUrl('/api/quotes'),
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Get all quotes with pagination and filters
export const getQuotes = async (page = 1, limit = 10, search = '', status = '', contact_id = '') => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (contact_id) params.append('contact_id', contact_id);
    
    const response = await api.get(`/?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get quote by ID
export const getQuoteById = async (id) => {
  try {
    const response = await api.get(`/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Create new quote
export const createQuote = async (quoteData) => {
  try {
    const response = await api.post('/', quoteData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update quote
export const updateQuote = async (id, quoteData) => {
  try {
    const response = await api.put(`/${id}`, quoteData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete quote
export const deleteQuote = async (id) => {
  try {
    const response = await api.delete(`/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Convert quote to receipt
export const convertQuoteToReceipt = async (id) => {
  try {
    const response = await api.post(`/${id}/convert-to-receipt`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default {
  getQuotes,
  getQuoteById,
  createQuote,
  updateQuote,
  deleteQuote,
  convertQuoteToReceipt,
};
